<template>
  <div class="flex flex-col items-center px-4 pt-2 pb-8 h-full justify-between">
    <div class="flex flex-col items-center h-fit">
      <div
        class="rounded-lg flex flex-col justify-center items-center bg-NAVY-BLUE relative px-4 pb-4 pt-2 h-[140px] w-[140px]"
      >
        <PirateFigure
          :image="pirateInfo.image"
          black-shadow
          class="!w-fit object-contain"
        ></PirateFigure>
        <div v-if="!pirateInfo.isOwned" class="z-10 absolute right-2 top-2">
          <img src="@/assets/icons/lock.svg" class="w-5 h-5 object-contain" />
        </div>
      </div>
      <div class="flex flex-col">
        <p class="text-lg font-semibold pt-6">{{ pirateInfo.name }}</p>
        <p class="text-sm font-normal pt-3">
          {{ pirateInfo.description }}
        </p>
      </div>
    </div>

    <div class="flex flex-col gap-6 pt-3 items-center w-full pb-3">
      <div
        v-if="!pirateInfo.isOwned && !pirateInfo.isUsed && !pirateInfo.diamond_only"
        class="flex flex-row items-center gap-1"
      >
        <p class="text-GREY text-xs pe-2">Price</p>
        <img class="w-5" src="@/assets/icons/token-2.svg" />
        <p class="font-semibold">{{ pirateInfo.price }}</p>
      </div>
      <div v-if="pirateInfo.diamond_only" class="flex flex-row items-center gap-1">
        <p class="text-GREY text-xs pe-2">Price</p>
        <img class="w-5" src="@/assets/icons/diamond.svg" />
        <p class="font-semibold">{{ pirateInfo.diamond_price }}</p>
      </div>
      <pow-button v-if="pirateInfo.isUsed" secondary class="w-full opacity-50" :loading="loading">
        <p>Current Character</p>
      </pow-button>
      <pow-button
        v-else-if="pirateInfo.isOwned"
        secondary
        class="w-full"
        :loading="loading"
        @click="use(pirateInfo), $emit('close'), closeBottomDrawer()"
      >
        <p>Use Character</p>
      </pow-button>
      <pow-button
        v-else
        tertiary
        class="w-full"
        :loading="loading"
        :disabled="(gameStore.totalToken + gameStore.calculatedTotalToken) < pirateInfo.price"
        @click="buy(pirateInfo)"
      >
        <p>Buy Character</p>
      </pow-button>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

import PowButton from '@/components/PowButton.vue'
import PirateFigure from '../PirateFigure.vue'
import { closeBottomDrawer } from '@/composables/bottomdrawer'

import { useGameStore } from '@/stores/game'
import { buyCharacter, changeCharacterOrSkin } from '@/services'

defineEmits(['close'])

const gameStore = useGameStore()

const props = defineProps({
  pirateInfo: {
    type: Object,
    required: true
  }
})
const loading = ref(false)

const buy = async (character) => {
  loading.value = true
  await buyCharacter({ id: character.id, with_diamond: false })
  gameStore.fetchUserSync()
  closeBottomDrawer()
  loading.value = false
}

const use = async (character) => {
  loading.value = true
  const res = await changeCharacterOrSkin({ id: character.id, action: 'change_character' })
  if (res.data == 'ok') {
    gameStore.activeCharacterId = character.id
  }
  closeBottomDrawer()
  loading.value = false
}
</script>
